import * as thorchain from '../../parser/thorchain';
import * as thormaya from './thormaya';
export class Parser extends thormaya.Parser {
    constructor(args) {
        super({
            chainId: args.chainId,
            parser: new thorchain.Parser({ midgardUrl: args.midgardUrl }),
        });
    }
}
